import React, { useEffect, useState } from 'react';
import "./pages.css";
import * as FeatherIcon from "react-feather";
import Button from 'react-bootstrap/Button';
import { unsubscribenewsletter } from '../../../services/authService';
import { PROJECT_DISPLAY_NAME } from '../../../config/apiConfig';

// Function to decode Base64 URL-encoded strings (decodes base64url without padding)
const base64UrlDecode = (str) => {
  try {
    // Replace URL-safe Base64 characters with standard Base64 characters
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    // Add padding if necessary
    const padding = base64.length % 4 === 0 ? '' : '='.repeat(4 - (base64.length % 4));
    return atob(base64 + padding);
  } catch (error) {
    // Return null or a specific message if decoding fails
    return null;
  }
};

export default function Unsubscribe() {
  const [status, setStatus] = useState('');
  const [email, setEmail] = useState('');
  const [ctaType, setCtaType] = useState('');
  const [userId, setUserId] = useState('');
  const [newsId, setNewsId] = useState('');
/*
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get('email');   
    const ctaTypeParam = params.get('cta_type');
    const userIdParam = params.get('user_id');
    const newsIdParam = params.get('news_id');
    // Decode Base64 email if needed
    if (emailParam) {
      const decodedEmail = base64UrlDecode(emailParam);
      //console.log("decodedEmail",decodedEmail);
      setEmail(decodedEmail);
    }    
  }, [])
  */

  useEffect(() => {
    // Extract URL parameters
    
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get('email');   
    const ctaTypeParam = params.get('cta_type');
    const userIdParam = params.get('user_id');
    const newsIdParam = params.get('news_id');
    const subjectParam = params.get('subject');
    const email = base64UrlDecode(params.get('email'));
    if(email){
            // Decode other URL parameters   
            const decodedCtaType = decodeURIComponent(ctaTypeParam || '');
            const decodedUserId = userIdParam ? base64UrlDecode(userIdParam) : ''; // Decode user_id if it exists
            const decodedSubject = base64UrlDecode(subjectParam || '');
            
            //const email = emailParam ? base64UrlDecode(emailParam) : '';
            // Call the API to verify the email and other parameters
            if (emailParam) {
            const requestData = {
                email: email,
                user_id: decodedUserId,
                cta_type: decodedCtaType,
                subject: decodedSubject          
            };
            console.log(requestData);
            verifyEmail(requestData);
            }
    }
    
  }, []);

  const verifyEmail = async (data) => {
    let my_data = await unsubscribenewsletter(data);             
        if (my_data.status == 201) {
          setStatus('Unsubscribed');
        } else {
          setStatus('Invalid Email Id');
        }      
  };

  return (
    <div>
        <div className="unscribe_wrapper mt-4 d-none1">
            <div className='container'>
                <div className='custom_card_block'>
                    <div className='unscribe'>
                        <div className='unscribe_icon_block'>
                            <img src="/img/unscribe.png" className='icon' alt="icon"/>
                        </div>
                        <div className='unscribe_text_block'>
                            <h5 className='unscribe_head'>{status}</h5>
                            <p className='text'>
                              {status == 'Unsubscribed' ? 
                                `We have disabled your Recommended Newsletter Alert. Please login to ${PROJECT_DISPLAY_NAME} to know more about your Preferences.` : 
                                'The provided email address is invalid.'}
                            </p>
                            <a href="/login" className='login_now'>
                              Yes, Login Now <FeatherIcon.ArrowRight className="fa" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>
  );
}
